import { render, staticRenderFns } from "./BasicChoice.vue?vue&type=template&id=260a5126&"
import script from "./BasicChoice.vue?vue&type=script&lang=js&"
export * from "./BasicChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('260a5126')) {
      api.createRecord('260a5126', component.options)
    } else {
      api.reload('260a5126', component.options)
    }
    module.hot.accept("./BasicChoice.vue?vue&type=template&id=260a5126&", function () {
      api.rerender('260a5126', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Wizard/StepOne/BasicChoice.vue"
export default component.exports